/* eslint-disable react-hooks/exhaustive-deps */
import React,{useMemo,useState} from "react";
import moment from  'moment';
import {SectorRenderer} from "../../sales/inner-components/renderers";
import { formatDateByTimezone} from '../../../utils/commonFunctions';

const CountTable = (props) => {

  return (<>  {props.mode==='paxSummary'?showPaxSummary(props):showSectorCapacity(props)}</>
  )
}
const showPaxSummary = (px) => {
  const { paxSum, headcountManifest } = px;

  const allZero = !paxSum?.ecy && !paxSum?.pc && !paxSum?.bc && !paxSum?.fc;

  return (
    <div className="flexCol" style={{ overflowY: 'auto', maxHeight: '200px' }}>
      <table className="sub-table">
        <thead style={{position: 'sticky', top: 0, backgroundColor: '#1a3a4a', zIndex: 10}}>
          <tr>
            <th style={{ backgroundColor: '#1a3a4a', position: 'sticky', top: 0 }}>Economy</th>
            <th style={{ backgroundColor: '#1a3a4a', position: 'sticky', top: 0 }}>Premium Economy</th>
            <th style={{ backgroundColor: '#1a3a4a', position: 'sticky', top: 0 }}>Business Class</th>
            <th style={{ backgroundColor: '#1a3a4a', position: 'sticky', top: 0 }}>First Class</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {allZero ? (
              <>
                <td>
                  {headcountManifest?.headcount ?? ""}
                </td>
                <td></td>
                <td></td>
                <td></td>
              </>
            ) : (
              <>
                <td>
                  {paxSum?.ecy ?? ""}
                </td>
                <td>{paxSum?.pc ?? ""}</td>
                <td>{paxSum?.bc ?? ""}</td>
                <td>{paxSum?.fc ?? ""}</td>
              </>
            )}
          </tr>
        </tbody>
      </table>
    </div>
  );
};


const showSectorCapacity = (px) => {
  const { status } = px;

  const allZero = status?.breakdown?.every(b => b.headcount === 0);

  const breakdownMap = {};
  status?.breakdown?.forEach(b => {
    breakdownMap[b.category] = b.headcount;
  });

  return (
    <div className="flexCol" style={{ overflowY: 'auto', maxHeight: '200px' }}>
      <table className="sub-table">
        <thead style={{position: 'sticky', top: 0, backgroundColor: '#1a3a4a', zIndex: 10}}>
          <tr>
            <th style={{ backgroundColor: '#1a3a4a', position: 'sticky', top: 0 }}>Economy</th>
            <th style={{ backgroundColor: '#1a3a4a', position: 'sticky', top: 0 }}>Premium Economy</th>
            <th style={{ backgroundColor: '#1a3a4a', position: 'sticky', top: 0 }}>Business Class</th>
            <th style={{ backgroundColor: '#1a3a4a', position: 'sticky', top: 0 }}>First Class</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {allZero ? (
              <>
                <td>{status?.headcount ?? ""}</td>
                <td></td>
                <td></td>
                <td></td>
              </>
            ) : (
              <>
                <td>{breakdownMap["EC"] ?? ""}</td>
                <td>{breakdownMap["PE"] ?? ""}</td>
                <td>{breakdownMap["BC"] ?? ""}</td>
                <td>{breakdownMap["FC"] ?? ""}</td>
              </>
            )}
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export const CateringSummary = (props) => {
  const { group, timezone,status,getCorrectedTailNo} = props
const [expandSector,setExpandSector] = useState(null);

const toggleSector = (sectorId) => {
  setExpandSector(prev =>prev === sectorId ? null : sectorId);
};

const rotationTimes = useMemo(() => {
  if (!group?.length) return { start: null, end: null };
let latestEstMap ={};
let paxSum = 0;
let categoryPax={'BC':0,'EC':0,'FC':0,'PE':0};

  const sorted = [...group].sort((a, b) =>new Date(a.item.startTime) - new Date(b.item.startTime));
  const first = sorted[0];
  const last = sorted[sorted.length - 1];
 group.forEach(g => { g.item?.sectors?.forEach(sector =>{latestEstMap[sector.id] = g.item});
 g.item?.latestEstimate?.headcountManifest?.byLeg?.forEach(leg => {
     leg.breakdown?.forEach(({ category, headcount }) => {
       categoryPax[category] = (categoryPax[category] || 0) + headcount;
     });
   });
}
);
 paxSum = (()=>{
 return group.reduce((sum, g) =>{return sum+(g?.item?.latestEstimate?.headcountManifest?.headcount)},0);
 })();
  return {
    date: first?.item?.date,
    startTime: first?.item?.startTime,
    endTime: last?.item?.endTime,
    sectorGroup:group.flatMap( g=> g.item.sectors),
    latestEstimates:latestEstMap,
    paxSum: isNaN(paxSum) ? '' : paxSum,
    categoryPax
  };
}, [group]);

  return (
    <div className="flexCol cntrl-calender-summary op-aircraft-container ng-grid-right flexCol full-flex ag-theme-alpine-dark">
      <span>
          <div className='table-header'></div>
          <table>
            <tbody>
            <tr >
              <td>Flight Date</td>
              <td>{moment(formatDateByTimezone(new Date(rotationTimes?.date))).format('DD-MM-YYYY')}</td>
            </tr>
            <tr>
            <td>STD</td>
            <td>{moment.utc(formatDateByTimezone(new Date(rotationTimes?.startTime), timezone === 'utc' ? true : false, true)).format("DD-MM-YYYY hh:mm A")}</td>
            </tr>

            <tr>
            <td>STA</td>
            <td>{moment.utc(formatDateByTimezone(new Date(rotationTimes?.endTime), timezone === 'utc' ? true : false, true)).format("DD-MM-YYYY hh:mm A")}</td>
            </tr>
            <tr>
              <td>Tail Number</td>
              <td>{status?getCorrectedTailNo(status.tailNumber) : ''}</td>
            </tr>
              <tr>
            </tr>
            <tr>
              <td>Pax Summary</td>
              <td>
                <CountTable 
                status={status} 
                flightDetails={null} 
                mode={"paxSummary"} 
                paxSum={{
                  ecy: rotationTimes?.categoryPax?.EC,
                  pc: rotationTimes?.categoryPax?.PE,
                  bc: rotationTimes?.categoryPax?.BC,
                  fc: rotationTimes?.categoryPax?.FC,
                }} 
                headcountManifest={{ headcount: rotationTimes?.paxSum }}
                />
              </td>
            </tr>
            <tr>
            <td colSpan={2} className="spl-row-class fontExtrabold" style={{textAlign:'center'}}>Sector Details</td>
            </tr>
           {group?.flatMap(g => g.item?.sectors || [])?.map((sector, index) => {
              const latestEstimateObj = rotationTimes?.latestEstimates?.[sector.id]?.latestEstimate ?? null;
          const legStatus = latestEstimateObj?.headcountManifest?.byLeg?.find(leg => leg.legId === sector.id);
            const isExpanded = expandSector === sector.id;

            const stDMoment = moment(sector.std);
            const stAMoment = moment(sector.sta);
            const timeDifference = moment.duration(stAMoment.diff(stDMoment));
            const hours = Math.floor(timeDifference.asHours());
            const min = timeDifference.minutes();

                return (
                   <React.Fragment key={sector.id}>
                  <tr key={index} style={{cursor:'pointer'}} onClick={() => toggleSector(sector.id)}>
                    <td> <div className='flexCol'>{SectorRenderer({ data: sector })}</div>
            <div className='flexCol margBottom10 margTop10'>
                  <label className='fontExtrabold margBottom10'>Flight Date</label>
                  <div className='flexCol'>
                  <div className='flexRow '>
                  {(() => {
                  const flightDate = moment(sector.flightDate);
                    const staDate = moment(sector.sta);

                      const dayDifference = staDate.startOf("day").diff(flightDate.startOf("day"), "days");

                      return (
                        <>
                          {flightDate.format("DD-MM-YYYY")}&nbsp;<strong style={{color:'#31a8ff'}}>{dayDifference > 0 && ` (+${dayDifference})`}</strong>
                        </>
                      );
                      })()}
                    </div>
            
                    </div>
                </div>
                  <div className='status-dynamic margBottom10 flexRow justifyContentSpaceBetween' style={{background:'#3e687d'}}>
                  <div className='flexCol justifyContentFlexStart'>
                  <label className='fontExtrabold margBottom10 width50'>STD</label>
            
                   <span className="caption-light">
                    {moment.utc(formatDateByTimezone(new Date(sector?.std), timezone === 'utc' ? true : false, true)).format("hh:mm A")}
                    </span> 
                    </div>
                  <div className='flexCol'>
       
                  <label className='fontExtrabold margBottom10'>STA</label>
                    <span className="caption-light">
                    {moment.utc(formatDateByTimezone(new Date(sector?.sta), timezone === 'utc' ? true : false, true)).format("hh:mm A")}
                    </span>
                    </div>
      
                 
                
                </div>
  
              <div className='margTop10 flexCol'>
       
                  <label className='fontExtrabold margBottom10'>Block Time</label>
                  <span className="code width50">{`${hours}h ${min}m`}</span>
                    </div>
                      
                    </td>
                    <td style={{background:isExpanded &&  expandSector === sector.id ? "#0b2a3a":''}}>
                      <CountTable
                        mode="paxSectors"
                        status={legStatus || null}
                      />
                    </td>
                  </tr>
                   {isExpanded && (
                    <tr>
                    <td colSpan={2} style={{ background: "#0b2a3a" }}>
                       
      
                  <label className='fontExtrabold margBottom10'>Operating Crew</label>
                        {sector.crew?.length ? (
                          <div className="crew-container margBotom10">
                            {sector.crew.map(member => (
                              <div
                                key={member.employeeId}
                                className="employee-crew"
                              >
                                <div className='flexRow no-wrap'>
                                {member.name}&nbsp;{member?.position ?`(${member.role} @ ${member.position})` : `(${member.role})`}
                                </div>
                                <div>{member.employeeCode}</div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          "No information about operating crew available."
                        )}
                 <div className='flexRow margBottom10 margTop10'>
                  <div className='flexCol margRight15'>
                  <label className='fontExtrabold margBottom10'>Flight Status</label>
                    <div className ="status-dynamic" style={{backgroundColor:'#1d3f4f'}}>
                    {sector.flightStatus.charAt(0).toUpperCase()+sector.flightStatus.slice(1)}
                    </div>
                    </div>

                  <div className='flexCol margRight15'>
                    <label className={`fontExtrabold ${!sector?.totalArrivalDelay ? 'margBottm20':'margBottom10'}`}>Total Arrival Delay</label>
                    {sector?.totalArrivalDelay ? <div className ="status-dynamic" style={{backgroundColor:'#b73021ff'}}>
                     {`${sector?.totalArrivalDelay?.formattedValue} ${sector?.totalArrivalDelay?.unit}`} 
                    </div>:<span>Unknown</span>}
                    </div>
            

                  <div className='flexCol'>
                  <label className={`fontExtrabold ${!sector?.totalDepartureDelay ? 'margBottm20':'margBottom10'}`}>Total Departure Delay</label>
                    {sector?.totalDepartureDelay ?<div className ="status-dynamic" style={{backgroundColor:'#c17a1eff'}}>
                    {`${sector?.totalDepartureDelay?.formattedValue} ${sector?.totalDepartureDelay?.unit}`}
                    </div>:<span >Unknown</span>}
                    </div>
                  </div>
                    </td>
                    </tr>
      )}
                   </React.Fragment>
                );
            })}
            </tbody>
          </table>
      </span>

    </div>

  )
}